import React from "react";
import { Button, Card, Icon, Input, Layout, PageHeader, Popconfirm, Spin, Table } from "antd";
import InProgressPopup from "./InProgressPopup";
import whatsapp from "@services/whatsapp";
import { alertPopup } from "@utils/popup";
import { inject, observer } from "mobx-react";
import * as styleClass from './style.scss'

@inject((store: any) => {
    const { authStore } = store

    return {
        authStore
    }
})
@observer
export default class Whatsapp extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            rawData: [],
            list: [],
            
            searchBy: 'phone',
            searchValue: '',
            searchInput: '',

            localUrlInput: '',

            loadingDNR: '',
            loadingReset: '',
            loadingDelete: '',
            loadingUrl: '',
            loadingStatus: '',
            dataLoading: false,
            inProgressOpen: '',
            inProgressData: '',
            localUrlId: '',
            stepList: {}
        }
    }

    // getDataInterval = null

    componentDidMount() {
        this.getSessions()
        this.getAllSteps()

        // this.getDataInterval =
        //     setInterval(() => this.getSessions() , 10000)
    }

    componentWillUnmount() {
        // clearInterval(this.getDataInterval)
    }

    getSessions = () => {
        const { authStore: { roles } } = this.props
        const { searchValue } = this.state
        this.setState({ loadingData: true })

        return whatsapp.getOpenSessions()
            .then((res) => {
                let list = res.data.filter(({ user_type }) => {
                    if (roles.includes('admin')) return true
                    return !['MANAGER', 'MENTOR', 'TESTER'].includes(user_type)
                })
                this.sortSessions(list)
                this.setState({ rawData: list }, () => this.handleSearchInput(searchValue))
            })
            .catch((error) => {
                console.log('error', error.response);
                // alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'לא ניתן להציג את המידע' })
            })
            .finally(() => this.setState({ loadingData: false }))
    }

    getAllSteps = () => {
        return whatsapp.getAllsteps()
            .then((res) => {
                let stepList = {}                
                res.data.forEach((step) => {
                    stepList[step.name] = step.description
                })
                this.setState({ stepList })
            })
            .catch((error) => {
                console.log(error);
            })
    }

    sortSessions = (sessions) => {
        sessions.sort((a, b) => {
            
            if (a.flow_name === 'CUSTOMER_SERVICE' && b.flow_name !== 'CUSTOMER_SERVICE') return -1;
            if (a.flow_name !== 'CUSTOMER_SERVICE' && b.flow_name === 'CUSTOMER_SERVICE') return 1;

            if (a.flow_name === 'CUSTOMER_SERVICE' && b.flow_name === 'CUSTOMER_SERVICE') {
                return new Date(a.updated_at) - new Date(b.updated_at);
            }

            if (a.flow_name != 'CUSTOMER_SERVICE' && b.flow_name != 'CUSTOMER_SERVICE') {
                return new Date(b.updated_at) - new Date(a.updated_at);
            }

            return 0;

        })
    }

    doNotRespond = (record) => {
        const { id, do_not_respond } = record
        this.setState({ loadingDNR: id }, () => {
            whatsapp.updateSession({ id, key: 'do_not_respond', value: !do_not_respond })
                // .then((res) => {
                //     console.log('doNotRespond res', res);
                // })
                .catch((error) => {
                    console.log('error', error.response);
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע' })
                })
                .finally(() => {
                    this.getSessions()
                    this.setState({ loadingDNR: '' })
                })
        })
    }

    resetSession = (sessionId) => {

        this.setState({ loadingReset: sessionId }, () => {

            return whatsapp.resetSession({ sessionId })
            .then((res) => {
                // console.log('reset res', res.data);
                this.getSessions()
            })
            .catch((error) => {
                console.log('reset error', error.response);
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע/בוצע באופן חלקי' })
            })
            .finally(() => {
                this.getSessions()
                this.setState({ loadingReset: '' })
            })
            
        })


    }

    deleteSession = (record) => {
        this.setState({ loadingDelete: record.id }, () => {
            whatsapp.deleteSession({ id: record.id })
                .then((res) => {
                    // console.log('delete res', res);
                    this.getSessions()
                })
                .catch((error) => {
                    console.log('delete error', error);
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע' })
                })
                .finally(() => this.setState({ loadingDelete: '' }))
        })
        
    }

    updateLocalUrl = (id) => {

        const { localUrlInput } = this.state

        this.setState({ loadingUrl: id }, () => {
            whatsapp.updateSession({ id, key: 'local_url', value: localUrlInput })
                .then((res) => {
                    console.log('local_url res', res);
                    this.getSessions()
                })
                .catch((error) => {
                    console.log('local_url error', error);
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע' })
                })
                .finally(() => {
                    this.setState({ loadingUrl: '', localUrlId: '' })
                })
        })

    }

    closeSession = (id) => {
        this.setState({ loadingStatus: id }, () => {
            whatsapp.updateSession({ id, key: 'status', value: 'CLOSED' })
                .then((res) => {
                    this.getSessions()
                })
                .catch((error) => {
                    console.log('error closeSession', error);
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע' })
                })
                .finally(() => {
                    this.setState({ loadingStatus: '' })
                })
        })
    }

    handleSearchInput = (e) => {
        const { searchBy } = this.state
        let value
        if (typeof e == 'string') value = e
        else value = e.target.value

        if (this.searchInputRules[searchBy]) {
            value = this.searchInputRules[searchBy](value)
        }

        // set input
        this.setState({ searchInput: value })

        // search
        if (searchBy == 'phone' && value[0] == '0') value = value.substring(1)

        this.setState({ searchValue: value }, () => {
            let list = [...this.state.rawData]
            if (value && value.length >= 2) {
                list = list.filter ((item) => item[searchBy].startsWith(value))
            }
            this.setState({ list })
        })

    }

    searchInputRules = {
        phone: (value) => {
            if (value) {
                value = value.replace(/\D/g, '')
            }
            return value
        }
    }

    highLightRowCondition = (record) => {
        const { updated_at, flow_name } = record

        if (flow_name == 'CUSTOMER_SERVICE') {
            return styleClass.highLightRow2
        } else if (flow_name && !flow_name.includes('MAIN_MENU') && new Date(updated_at) < (new Date() - 3600000))  {
            return styleClass.highLightRow1
        } else if (flow_name == 'NOT_REGISTERED') {
            return styleClass.highLightRow4
        } else {
            return styleClass.highLightRow3
        }
    }

    clientPageLink = (record, columns) => {
        let type = 'clients'
        if (['AGENT', 'AGENT&CLIENT'].includes(record.current_user_type)) type = 'agents'

        const isPhone = columns.includes('phone')
        

        const url = isPhone ? 
            `https://live.wati.io/105861/teamInbox/${record.conversation_id}?filter={%22filterType%22:5}` :
            `/${type}/${record.user_id}`

        const style = {
            fontWeight: '600',
            color: isPhone ? '#1cb934' : '#0000a3'
        }

        return ['MENTOR', 'MANAGER', 'TESTER'].includes(record.user_type) ? (
            <span style= {style}>
                {columns.map((col) => `${record[col]}`)}
            </span>
        ) : (
            <a
                target="_blank"
                style= {style}
                href={url}
            >
                {columns.map((col) => `${record[col]} `)}
            </a>
        )
    }

    userColumns = [
        {
            title: 'שם',
            key: 'full_name',
            align: 'right',
            render: (_, record) => {
                const inProgress = record.in_progress ? JSON.parse(record.in_progress) : null
                if (inProgress && inProgress.authorized) {
                    return <span>{`${inProgress.authorized.name}`}</span>
                } else if (!record.first_name) {
                    return <span>{`${record.sender_name}`}</span>
                }
                return this.clientPageLink(record, ['first_name', 'last_name'])
            }
        },
        {
            title: 'טלפון',
            key: 'phone',
            align: 'right',
            render: (_,record) => this.clientPageLink(record, ['phone'])
        },
        {
            title: 'מזהה משתמש',
            key: 'user_id',
            align: 'right',
            render: (_,record) => {
                if (!record.user_id) {
                    const inProgress = record.in_progress ? JSON.parse(record.in_progress) : null
                    if (inProgress && inProgress.authorized) {
                        return <a
                                    target="_blank"
                                    style= {{ fontWeight: '600', color: '#0000a3' }}
                                    href={`/agents/${inProgress.authorized.user_id}`}
                                >
                                    מורשה ({inProgress.authorized.user_id})
                                </a>
                    } else return '-'
                }
                return this.clientPageLink(record, ['user_id'])
            }
        },
        {
            title: 'סוג משתמש',
            key: 'user_type',
            align: 'right',
            render: (_, record) => <span>{`${USER_TYPES[record.user_type] || ''}`}</span>
        },
        {
            title: 'מחובר כ-',
            key: 'current_user_type',
            align: 'right',
            render: (_, record) => <span>{`${USER_TYPES[record.current_user_type] || ''}`}</span>
        },
        {
            title: 'תהליך',
            key: 'flow_id',
            align: 'right',
            render: (_, record) => <span>{`${record.flow_description || ''}`}</span>
        },
        {
            title: 'שלב',
            key: 'flow_step',
            align: 'right',
            render: (_, record) => {
                if (!record.flow_id) return ''
                
                const { stepList } = this.state
                const { flow_steps, sub_flow_steps, sub_flow_id, flow_step, sub_flow_step } = record
                let steps = sub_flow_id ? JSON.parse(sub_flow_steps) : JSON.parse(flow_steps)
                let currentStep = sub_flow_id ? sub_flow_step : flow_step
                let name = steps[currentStep]

                return (
                    <span>{`${stepList[name] || ''}`}</span>
                )
            }
        },
        {
            title: 'תוכן',
            key: 'in_progress',
            align: 'right',
            render: (_, record) => {
                
                const handle = () => {
                    this.setState({
                        inProgressOpen: record.id,
                        inProgressData: record.in_progress
                    })
                }
                return (
                    <Button disabled={!record.in_progress} onClick={handle}>{"צפייה"}</Button>
                )
            }
        },
        {
            title: 'מצב בוט',
            key: 'do_not_respond',
            align: 'right',
            render: (_, record) => {
                const { loadingDNR, loadingStatus } = this.state
                const { do_not_respond, id, flow_name, status, updated_at } = record
                const updatedAtStr = updated_at.replace(/-/g, '/').slice(0, updated_at.lastIndexOf(':'))
                
                if (flow_name == 'CUSTOMER_SERVICE' && new Date(updated_at) < new Date(Date.now() - 24 * 60 * 60 * 1000)) {
                    return  (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Popconfirm
                                title={'האם לסמן כ-״טופל״?'}
                                okText={'כן'}
                                cancelText={'לא'}
                                onConfirm={() => this.closeSession(record.id)}
                                >
                                <Button>{'סגירה'}</Button>
                            </Popconfirm>
                            {loadingStatus == record.id ? <Spin /> : <div style={{ width: '20px' }}></div>}
                            <div>{`פעילות אחרונה: ${updatedAtStr}`}</div>
                        </div>
                    )
                    
                } else {
                    return loadingDNR == id ? (
                        <Spin />
                    ) : (
                        <div style={{ display: 'flex',  }}>
    
                            {flow_name !== 'CUSTOMER_SERVICE' ? do_not_respond ?
                                <span style={{ ...styles.button, ...styles.buttonRight, color: 'red' }}>{"מושהה"}</span> :
                                <span style={{ ...styles.button, ...styles.buttonRight, color: 'green' }}>{"פעיל"}</span> : null}
                            <Popconfirm
                                onConfirm={() => this.doNotRespond(record)}
                                title={"האם את/ה בטוח/ה?"}
                                cancelText={"לא"}
                                okText={"כן"}
                            >
                                {flow_name !== 'CUSTOMER_SERVICE' ? <span style={{ ...styles.button, ...styles.buttonLeft }}>
                                    {`${do_not_respond ? 'הפעלה' : 'השהייה'}`}
                                </span> : null}
                            </Popconfirm>
                            {flow_name == 'CUSTOMER_SERVICE' ? (<div>{`פעילות אחרונה: ${updatedAtStr}`}</div>) : ''}
                        </div>
                    )
                }

            }
        },
        {
            title: '',
            key: 'reset',
            align: 'right',
            render: (_, record) => {
                const { loadingReset } = this.state
                const { updated_at, flow_name } = record
                const loading = loadingReset == record.id

                return (flow_name == 'CUSTOMER_SERVICE' && new Date(updated_at) > new Date(Date.now() - 24 * 60 * 60 * 1000)) || flow_name !== 'CUSTOMER_SERVICE' ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Popconfirm
                            title={"איפוס שיחה?"}
                            onConfirm={() => this.resetSession(record.id)}
                            okText={"כן"}
                            cancelText={"לא"}
                            >
                            <Button disabled={loading}>{"איפוס"}</Button>
                        </Popconfirm>
                        {loading ? <Spin/> : <div style={{ width: '20px' }}></div>}
                    </div>
                ) : null
            }
        }
    ]

    adminColumns = [
        {
            title: '',
            key: 'local_url',
            render: (_, record) => {
                const { localUrlId, loadingUrl } = this.state
                if (record.local_url) {
                    if (localUrlId == record.id) {
                        return (
                            <div style={{ display: 'flex' }}>
                                <Input onChange={(e) => this.setState({ localUrlInput: e.target.value })} style={{ ...styles.urlInput }} />
                                {loadingUrl == record.id ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '68px' }}>
                                        <Spin />
                                    </div> : 
                                    <>
                                        <button onClick={() => this.setState({ localUrlId: '' })} style={{ ...styles.button }}>
                                            <span style={{ rotate: '45deg', fontSize: '24px', margin: '0 0 3px 3px' }}>+</span>
                                        </button>
                                        <button onClick={() => this.updateLocalUrl(record.id)} style={{ ...styles.button }}>
                                            <Icon style={{ marginBottom: '-8px' }} type="check" />
                                        </button>
                                    </>}
                            </div>
                        )
                        
                    } else {
                        return (
                            <Button onClick={() => this.setState({ localUrlId: record.id })}>
                                {"URL"}
                            </Button>
                        )
                    }        
                } else return ''
            }
        },
        {
            title: '',
            key: 'delete23',
            align: 'right',
            render: (_, record) => {
                const { loadingDelete } = this.state
                return (
                    <Popconfirm
                        onConfirm={() => this.deleteSession(record)}
                        title="האם למחוק?"
                        okText="כן"
                        cancelText="לא"
                    >
                        <Button>
                            <Icon type="delete" />
                        </Button>
                        {loadingDelete == record.id ? <Spin /> : <div style={{ width: '20px' }}></div>}
                    </Popconfirm>
                )
            }
        }
    ]



    // phone links to: 
    // https://live.wati.io/105861/teamInbox/${conversation_id}?filter={%22filterType%22:5}

    render() {
        const { list, loadingData, inProgressData, inProgressOpen, searchInput } = this.state
        const { authStore } = this.props

        let columns = [...this.userColumns]
        if (authStore.roles.includes('admin')) columns.push(...this.adminColumns)
        return (
            <>
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title={"שיחות WhatsApp"}
                />

                <Card
                    title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ ...styles.searchTitle }}>{"חיפוש לפי טלפון: "}</span>
                                <Input style={{ ...styles.searchInput }} value={searchInput} onChange={this.handleSearchInput} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Button onClick={this.getSessions}><Icon type="reload" /></Button>
                                {loadingData ? <Spin style={{ marginLeft: '10px' }} /> : <div style={{ width: '30px' }}></div>}
                            </div>
                        </div>
                    }
                    headStyle={{ backgroundColor: '#dadce0' }}
                    bodyStyle={{ padding: '0.8rem 0.8rem' }}
                    style={{ marginBottom: '1rem' }}
                >
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={{ pageSize: 50 }}
                        rowClassName={(record) => this.highLightRowCondition(record)}
                    />
                </Card>
                
            </Layout>
            <InProgressPopup visible={inProgressOpen} inProgressData={inProgressData}  close={() => this.setState({ inProgressOpen: '' })}/>
            </>
        )
    }
}

const USER_TYPES = {
    'LEAD': 'ליד',
    'MENTOR': 'מנטור',
    'MANAGER': 'מנהל',
    'CLIENT': 'לקוח',
    'AGENT': 'סוכן',
    'AGENT&CLIENT': 'סוכן ולקוח',
    'TESTER': 'בדיקות'
}

const STATUSES = {
    OPEN: 'פתוח',
    CLOSED: 'סגור'
}

const styles = {
    searchTitle: { marginLeft: '10px' },
    searchInput: {  },
    urlInput: { height: '34px' },
    button: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        borderRadius: '4px',
        height: '34px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '34px'
    },
    buttonRight: { borderRadius: '0 4px 4px 0', width: '70px' },
    buttonLeft: { borderRadius: '4px 0 0 4px', width: '74px', cursor: 'pointer' }
}


